import { z } from "zod";
import { IsoDateTime, OpaqueId, Seq } from "./common.js";
import { PositionType } from "./journey.js";
/**
 * Rejeu de journée (CDC §12.4, backlog Phase 2 P2-32). Outil **hors
 * régulation** : relire une période passée sur la carte, avec les mêmes
 * filtres que la carte live. Le serveur sert les trames enregistrées d'une
 * fenêtre ; le contrôleur de lecture (play / pause / vitesse / curseur) est
 * entièrement côté frontend, il déroule les trames à la cadence voulue.
 *
 * Aucune exclusion de périmètre décisionnel : c'est une observation du passé,
 * pas un outil d'aide à la décision.
 */
/** État d'une course dans une trame — juste ce qu'il faut pour la redessiner. */
export const ReplayJourney = z.object({
    id: OpaqueId,
    lineId: OpaqueId,
    lineCode: z.string(),
    direction: z.union([z.literal(0), z.literal(1)]),
    headsign: z.string(),
    lat: z.number().nullable(),
    lon: z.number().nullable(),
    bearing: z.number().min(0).lt(360).nullable(),
    positionType: PositionType,
    deviationSeconds: z.number().int(),
    vehicleDisplayNumber: z.string().nullable(),
    runId: z.string().nullable(),
    serviceId: z.string().nullable(),
});
export const ReplayFrame = z.object({
    at: IsoDateTime,
    seq: Seq,
    journeys: z.array(ReplayJourney),
});
export const ReplayResponse = z.object({
    networkId: z.string(),
    from: IsoDateTime,
    to: IsoDateTime,
    frameCount: z.number().int().nonnegative(),
    /** `true` si la fenêtre contient plus de trames que la limite serveur — réduire l'intervalle. */
    truncated: z.boolean(),
    frames: z.array(ReplayFrame), // ordre chronologique
});
export const ReplayBoundsResponse = z.object({
    earliest: IsoDateTime.nullable(),
    latest: IsoDateTime.nullable(),
    frameCount: z.number().int().nonnegative(),
    /** Cadence nominale d'enregistrement — cale le pas du curseur du contrôleur de lecture. */
    intervalSeconds: z.number().int(),
    /** Fenêtre de rétention de l'enregistrement (décision D4). */
    retentionDays: z.number().int(),
});
//# sourceMappingURL=replay.js.map